const ColorSwatch = require('okCharts/ColorSwatch');

module.exports = ColorSwatch;
